/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { NextPage } from "next";
import React from "react";

export type LayoutComponent = React.ReactNode | Element;

export enum DEFAULT_LAYOUT_TYPE {
  BLANK = "BLANK", // 로고만 있는 레이아웃
  PROFILE = "PROFILE", // 팀을 선택할 수 있는 레이아웃
  ORGANIZATION = "ORGANIZATION", // 팀을 선택한 레이아웃
  SITE = "SITE", // 사이트를 선택한 레이아웃
  CAMPAIGN = "CAMPAIGN", // 캠페인을 선택한 레이아웃
}

export enum V2_DEFAULT_LAYOUT_TYPE {
  LOGO = "LOGO", // 헤더에 로고만 있는 레이아웃
  HEADER = "HEADER", // 헤더만 있는 레이아웃
  DEFAULT = "DEFAULT", // 사이드바와 헤더가 있는 레이아웃
  AI = "AI", // AI 레이아웃
}

export enum V2_AGREE_LAYOUT_TYPE {
  DEFAULT = "DEFAULT",
}

export enum V2_EDITOR_LAYOUT_TYPE {
  POPUP = "POPUP",
  INSTAGRAM = "INSTAGRAM",
  BANNER = "BANNER",
  CHILD_POPUP = "CHILD_POPUP",
  POPUP_GROUP = "POPUP_GROUP",
  BANNER_GROUP = "BANNER_GROUP",
  FORM_EVENT = "FORM_EVENT",
  FORM_SURVEY = "FORM_SURVEY",
  PROMOTION = "PROMOTION",
}

interface IDefaultLayoutProfileProps {
  // organizations: IOrganization[] | null;
}

export interface IDefaultLayoutOrganizationProps {
  // organizations: IOrganization[];
  // currentOrganization: IOrganization;
}

export interface IDefaultLayoutSiteProps
  extends IDefaultLayoutOrganizationProps {
  // currentSite: ISite;
}

export interface IDefaultLayoutV2Props extends IDefaultLayoutOrganizationProps {
  // currentSite: ISite | null;
}

type EmptyLayoutEditorProps = IDefaultLayoutSiteProps;

export type LayoutNextPage =
  | NextPage
  | NextPage<IDefaultLayoutProfileProps>
  | NextPage<IDefaultLayoutOrganizationProps>
  | NextPage<IDefaultLayoutSiteProps>
  | NextPage<EmptyLayoutEditorProps>
  | NextPage<IDefaultLayoutV2Props>;

export interface ILayoutPage<T = {}> extends React.FC<T> {
  getLayout?: (
    page: LayoutNextPage,
    props: { [key: string]: unknown }
  ) => JSX.Element;
}

export const isProfileLayout = (
  Page: LayoutNextPage,
  layoutType: DEFAULT_LAYOUT_TYPE
): Page is NextPage<IDefaultLayoutProfileProps> => {
  return layoutType === DEFAULT_LAYOUT_TYPE.PROFILE;
};

export const isOrganizationLayout = (
  Page: LayoutNextPage,
  layoutType: DEFAULT_LAYOUT_TYPE
): Page is NextPage<IDefaultLayoutOrganizationProps> => {
  return layoutType === DEFAULT_LAYOUT_TYPE.ORGANIZATION;
};

export const isSiteLayout = (
  Page: LayoutNextPage,
  layoutType: DEFAULT_LAYOUT_TYPE
): Page is NextPage<IDefaultLayoutSiteProps> => {
  return layoutType === DEFAULT_LAYOUT_TYPE.SITE;
};

export const isCampaignLayout = (
  Page: LayoutNextPage,
  layoutType: DEFAULT_LAYOUT_TYPE
): Page is NextPage<IDefaultLayoutSiteProps> => {
  return layoutType === DEFAULT_LAYOUT_TYPE.CAMPAIGN;
};
